import React, { useState } from "react"

import PaymentDirectory from "../../components/pro_portal/payments/PaymentDirectory"
import { Button } from "../../components/shared/Buttons"
import GraphQLProvider from "../../providers/GraphQLProvider"

import ChargeClientCardModal from "./ChargeClientCardModal"
import ClientPageView from "./ClientPageView"
import ManageCreditCard from "./ManageCreditCard"

const Billing = ({
  client: clientProp,
  upcomingAppointments,
  communicationSettings,
  practice,
  manualChargeEnabled,
  clientNotesEnabled,
  multipleIntakeFormsEnabled
}) => {
  const [client] = useState(clientProp)
  const [chargeModalOpen, setChargeModalOpen] = useState(false)
  const [paymentDirectoryKey, setPaymentDirectoryKey] = useState(0)
  const showChargeCard = !!(manualChargeEnabled && practice.hasPaymentProvider)

  return (
    <ClientPageView
      client={client}
      practice={practice}
      upcomingAppointments={upcomingAppointments}
      clientNotesEnabled={clientNotesEnabled}
      multipleIntakeFormsEnabled={multipleIntakeFormsEnabled}
      path={`/portal/clients/${client.id}/billing`}>
      <div className="mb-6 w-full rounded-xl border border-gray p-8">
        <div className="mb-2 flex flex-row items-center justify-between gap-3">
          <div className="font-bold">Payment Method</div>
          {showChargeCard && (
            <Button type="primary" size="small" onClick={() => setChargeModalOpen(true)}>
              Charge card
            </Button>
          )}
        </div>
        <ManageCreditCard client={client} practice={practice} />
      </div>
      <PaymentDirectory key={paymentDirectoryKey} communicationSettings={communicationSettings} clientId={client.id} />
      <ChargeClientCardModal
        visible={chargeModalOpen}
        hideModal={() => setChargeModalOpen(false)}
        client={client}
        defaultCurrency={practice.defaultCurrency}
        practiceId={practice.id}
        onCharged={() => setPaymentDirectoryKey((k) => k + 1)}
      />
    </ClientPageView>
  )
}

export default function ClientBillingPage(props) {
  return (
    <GraphQLProvider>
      <Billing {...props} />
    </GraphQLProvider>
  )
}
